import { render, staticRenderFns } from "./LaboratoryPromocodeItem.vue?vue&type=template&id=2bcab359&scoped=true"
import script from "./LaboratoryPromocodeItem.vue?vue&type=script&lang=js"
export * from "./LaboratoryPromocodeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcab359",
  null
  
)

export default component.exports